import { render, staticRenderFns } from "./actitems.vue?vue&type=template&id=5680a0e4&"
import script from "./actitems.vue?vue&type=script&lang=js&"
export * from "./actitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports